"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageActions = exports.SubPageNames = exports.PageNames = void 0;
var PageNames;
(function (PageNames) {
    PageNames["TIMECARD"] = "Timecard";
    PageNames["PUNCH_WORKFLOW"] = "PunchWorkflow";
    PageNames["REPORT_TRAVEL_TIME_WORKFLOW"] = "ReportTravelTimeWorkflow";
})(PageNames = exports.PageNames || (exports.PageNames = {}));
var SubPageNames;
(function (SubPageNames) {
    SubPageNames["PAY_PERIOD_PICKER"] = "payPeriodPicker";
    SubPageNames["PAY_PERIOD_HOURLY_BREAKDOWN"] = "payPeriodHourlyBreakdown";
    SubPageNames["PAY_PERIOD_DAILY_BREAKDOWN"] = "payPeriodDailyBreakdown";
    SubPageNames["REQUEST_CORRECTION_MODAL"] = "requestCorrectionModal";
    SubPageNames["TASK_LIST"] = "taskList";
    SubPageNames["PUNCH_CORR_STATUS_MODAL"] = "punchCorrStatusModal";
    SubPageNames["SELECT_DATE"] = "selectDate";
    SubPageNames["SELECT_ACTION"] = "selectAction";
    SubPageNames["SELECT_PUNCH"] = "selectPunch";
    SubPageNames["EDIT_PUNCH"] = "editPunch";
    SubPageNames["REVIEW"] = "review";
    SubPageNames["SUMMARY"] = "summary";
    SubPageNames["REPORT_TRAVEL_TIME"] = "reportTravelTime";
    SubPageNames["REPORT_TRAVEL_TIME_REVIEW"] = "reportTravelTimeReview";
})(SubPageNames = exports.SubPageNames || (exports.SubPageNames = {}));
var PageActions;
(function (PageActions) {
    PageActions["ARRIVE_AT_TIMECARD"] = "mainpage-rendered";
    PageActions["GO_TO_PREVIOUS_PAY_PERIOD"] = "previouspayperiod-click";
    PageActions["GO_TO_NEXT_PAY_PERIOD"] = "nextpayperiod-click";
    PageActions["CLICK_ON_DAY_WITH_ANOMALIES"] = "daywithanomalies-click";
    PageActions["CLICK_ON_DAY_WITHOUT_ANOMALIES"] = "day-click";
    PageActions["CLICK_SEE_TODAY_BUTTON"] = "seetoday-click";
    PageActions["CLICK_REQUEST_CORRECTION_BUTTON"] = "requestcorrection-click";
    PageActions["RCMODAL_CORRECT_UNPAID_TIME_OR_ATTENDANCE"] = "correctunpaidtime-click";
    PageActions["RCMODAL_CORRECT_TIME_OFF_REQUESTS"] = "correcttimeoffrequests-click";
    PageActions["RCMODAL_VIEW_PUNCH_CORRECTION_REQUESTS"] = "viewpunchcorrectionrequests-click";
    PageActions["RCMODAL_REPORT_ABSENCE_LATENESS"] = "reportabsencelateness-click";
    PageActions["RCMODAL_CLOSE_MODAL"] = "closemodal-click";
    PageActions["CLICK_UNPAID_TIME_DETAILS"] = "unpaidtime-click";
    PageActions["CLICK_SEE_PAY_LINK"] = "seepay-click";
    PageActions["VISIT_TASK_LIST_FROM_TIMECARD"] = "viewtasklist-click";
    PageActions["ARRIVE_AT_TASK_LIST"] = "tasklist-rendered";
    PageActions["CLICK_TASK_LIST_LEARN_MORE"] = "tasklistlearnmore-click";
    PageActions["CLICK_NOT_ACCEPTED_REQUEST"] = "notacceptedrequest-click";
    PageActions["CLICK_DUPLICATED_PUNCH"] = "duplicatedpunch-click";
    PageActions["CLICK_MISSING_PUNCH"] = "missingpunch-click";
    PageActions["CLICK_SYSTEM_ADDED_PUNCH"] = "systemaddedpunch-click";
    PageActions["CLICK_PENDING_REQUEST"] = "pendingrequest-click";
    PageActions["CLICK_ACCEPTED_REQUEST"] = "acceptedrequest-click";
    PageActions["PCSMODAL_CLOSE_MODAL"] = "closepcsmodal-click";
    PageActions["CHANGE_CALENDAR_DATE"] = "calendardate-change";
    PageActions["CLICK_PUNCH_ACTION"] = "punchaction-click";
    PageActions["CLICK_PUNCH"] = "punch-click";
    PageActions["CHANGE_PUNCH_TIME"] = "punchtime_change";
    PageActions["CHANGE_PUNCH_DATE"] = "punchdate_change";
    PageActions["SUBMIT_PUNCH_WORKFLOW"] = "punchworkflow-submit";
    PageActions["CLICK_BACK"] = "back-click";
    PageActions["CLICK_CONTINUE"] = "continue-click";
    PageActions["CLOSE_PUNCH_WORKFLOW"] = "punchworkflow-close";
    PageActions["ARRIVE_SELECT_DATE_STEP"] = "selectdate-rendered";
    PageActions["ARRIVE_SELECT_ACTION_STEP"] = "selectaction-rendered";
    PageActions["ARRIVE_SELECT_PUNCH_STEP"] = "selectpunch-rendered";
    PageActions["ARRIVE_EDIT_PUNCH_STEP"] = "editpunch-rendered";
    PageActions["ARRIVE_REVIEW_STEP"] = "review-rendered";
    PageActions["ARRIVE_SUMMARY_STEP"] = "summary-rendered";
    PageActions["TRAVEL_START_DATE_CHANGE"] = "travelstartdate-change";
    PageActions["TRAVEL_START_TIME_CHANGE"] = "travelstarttime-change";
    PageActions["TRAVEL_END_DATE_CHANGE"] = "travelenddate-change";
    PageActions["TRAVEL_END_TIME_CHANGE"] = "travelendtime-change";
    PageActions["TRAVEL_MEAL_START_TIME_CHANGE"] = "travelmealstarttime-change";
    PageActions["TRAVEL_MEAL_DURATION_CHANGE"] = "travelmealduration-change";
    PageActions["TRAVEL_REASON_CHANGE"] = "travelreason-change";
    PageActions["SUBMIT_TRAVEL_TIME_WORKFLOW"] = "reporttraveltimeworkflow-submit";
    PageActions["CLOSE_TRAVEL_TIME_WORKFLOW"] = "reporttraveltimeworkflow-close";
    PageActions["ARRIVE_REPORT_TRAVEL_TIME_STEP"] = "reporttraveltimestep-rendered";
    PageActions["ARRIVE_REPORT_TRAVEL_TIME_REVIEW_STEP"] = "reporttraveltimereviewstep-rendered";
    PageActions["ARRIVE_REPORT_TRAVEL_TIME_SUMMARY_STEP"] = "reporttraveltimesummarystep-rendered";
})(PageActions = exports.PageActions || (exports.PageActions = {}));
